export enum RestaurantOwnerActionTypes {
    GET_FACEBOOK_PAGES = 'establishment/GET_FACEBOOK_PAGES',
    GET_GOOGLE_PAGES = 'establishment/GET_GOOGLE_PAGES',
}

export interface RestaurantOwnerState {}
